import { supabase } from '@/integrations/supabase/client';

// Only two severity levels are permitted (D-06)
type Severity = 'error' | 'info';

interface LogContext {
  [key: string]: unknown;
}

export async function logError(
  severity: Severity,
  source: string,
  message: string,
  context?: LogContext
): Promise<void> {
  // Get current user ID if available (non-blocking)
  const { data: { session } } = await supabase.auth.getSession();
  const userId = session?.user?.id ?? null;

  // Insert into error_logs table (severity IN ('error', 'info'))
  const { error } = await supabase.from('error_logs').insert({
    severity,
    source,
    message,
    context: context ?? {},
    user_id: userId,
  });

  // Fallback: if DB insert fails, write to console in development only (D-07)
  if (error && import.meta.env.DEV) {
    console.error(`[logError fallback] ${severity}/${source}: ${message}`, context, error);
  }
}
